import React from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const TinyEditor = ({ value, onChange, height = 400, readOnly = false, className = "" }) => {
  return (
    <div className={`quill-editor-wrapper ${className}`.trim()}>
      <style>
        {`
          .quill-editor-wrapper .ql-container {
            font-family: Helvetica, Arial, sans-serif;
            font-size: 14px;
          }
          .quill-editor-wrapper .ql-editor {
            min-height: ${height}px;
            line-height: 1.6;
          }
          .quill-editor-wrapper .ql-editor p {
            margin: 0 0 0.5em 0;
          }
          .quill-editor-wrapper .ql-editor p:last-child {
            margin-bottom: 0;
          }
          .quill-editor-wrapper .ql-editor p:empty,
          .quill-editor-wrapper .ql-editor p:has(> br:only-child) {
            margin: 0;
            min-height: 1.25em;
            line-height: 1.25;
          }
          .quill-editor-wrapper.package-field-text .ql-container,
          .quill-editor-wrapper.package-field-text .ql-editor {
            font-size: 0.875rem;
            font-weight: 500;
            color: #1f2937;
          }
          .quill-editor-wrapper.package-field-text .ql-toolbar.ql-snow {
            font-size: 0.8125rem;
          }
          .quill-editor-wrapper.package-field-text .ql-toolbar .ql-picker-label,
          .quill-editor-wrapper.package-field-text .ql-toolbar button {
            font-size: inherit;
          }
          .quill-editor-wrapper .ql-toolbar.ql-snow {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
            border-color: #d1d5db;
            background: #fff;
          }
          .quill-editor-wrapper .ql-container.ql-snow {
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            border-color: #d1d5db;
            background: #fff;
          }
        `}
      </style>
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={(content, _delta, source) => {
          if (onChange && source === "user") {
            onChange(content);
          }
        }}
        readOnly={readOnly}
      />
    </div>
  );
};

export default TinyEditor;
